module.exports = __webpack_public_path__ + "img/744.da1541dc.jpg";